import { Theme } from "../../../../Style/Theme";

//TODO: Width and height may be move to  message box
export const ConfirmMessageBoxStyle = {
  overflow: "hidden",
  position: "absolute",
  top: "27.5%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "408px",
  minHeight: "222.333px",
  width: "auto",
  backgroundColor: Theme.palette.background.pureWhite,
  boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",
  borderRadius: "8px",
  padding: "16px 20px",
  justifyContent: "center",
};

export const ConfirmMessageBoxStyle2 = {
  overflow: "hidden",
  position: "absolute",
  top: "35.5%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "408px",
  minHeight: "222.333px",
  width: "auto",
  backgroundColor: Theme.palette.background.pureWhite,
  boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",

  padding: "16px 20px",
  justifyContent: "center",
};

export const ConfirmationMessageBoxCloseStyle = {
  position: "absolute",
  top: "1px",
  right: "0px",
};

export const ConfirmationMessageBoxButtonStyle = {
  padding: "12px 20px",
  width: "176px",
  height: "42px",
};

export const ConfirmationMessageBoxButtonStyle2 = {
  padding: "12px 20px",
  width: "100%",
  minHeight: "46px",
};
